import { Card, CardContent, CardHeader, Grid, Skeleton, Typography } from "@mui/material";
import { GridColumnConfig, GridPreference } from "../../../../models/gridCoumnConfig";
import { SiTrackGrid } from "../../../../components/si-track-grid/si-track-grid";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { gridApiKeyStore } from "../../../../api/grid-api-key-store";
import { useSaveData } from "../../../../hooks/useSaveData";
import { useEffect, useState } from "react";
import { State } from "@progress/kendo-data-query";
import useDebounce from "../../../../hooks/use-debounce";


export const assignedWorkOrderColumns: GridColumnConfig[] = [
    {
        title: 'Customer Name',
        field: 'customerName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Office Name',
        field: 'officeName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Project Name',
        field: 'projectName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Jobsite',
        field: 'jobsite',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Service Name',
        field: 'serviceName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'WO#',
        field: 'workOrderNumber',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Work Order Status',
        field: 'workOrderStatus',
        filter: 'text',
        searchable: true,
    },
];


interface AssignedWorkorderInspection {
    inspectorWOEvents: any;
    isLoading: boolean;
}

export const AssignedWorkorderInspection = ({ inspectorWOEvents, isLoading }: AssignedWorkorderInspection) => {

    // -------------------------------------------------Grid Layout------------------------------

    const {
        isLoading: isLoadingGridLayout,
        data: gridLayouts,
        refetch: refetchGridLayout,
    } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('AssignedWorkOrder', 'AssignedWorkOrder'));

    const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
    const [gridConfig, setGridConfig] = useState<{
        dataState: State | undefined;
        columns: any[] | undefined;
    }>();

    const [filteredAssignedWorkOrders, setFilteredAssignedWorkOrders] = useState<any[]>([]);

    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 300);

    useEffect(() => {
        const filteredAssignedWorkOrderList = inspectorWOEvents?.filter((AssignedWorkOrder: any) =>
            Object.values(AssignedWorkOrder).some(
                (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
            )
        );
        setFilteredAssignedWorkOrders(filteredAssignedWorkOrderList || []);
    }, [debouncedSearchTerm, inspectorWOEvents]);

    const handleInputChange = (value: string) => {
        setSearchTerm(value);
    };

    const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
        const data = {
            filterJSON: JSON.stringify(gridDataState),
            columnJSON: JSON.stringify(gridColumns),
            gridName: 'AssignedWorkOrder',
            pageName: 'AssignedWorkOrder',
        };

        mutateAsync({ data }).then(() => {
            refetchGridLayout();
        });
    };

    const handleResetLayout = () => {
        const data = {
            filterJSON: null,
            columnJSON: null,
            gridName: 'AssignedWorkOrder',
            pageName: 'AssignedWorkOrder',
        };

        mutateAsync({ data }).then(() => {
            refetchGridLayout();
        });
    };

    useEffect(() => {
        if (!gridLayouts?.data) return;

        try {
            const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

            const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

            // if (filterData && columnJson) {
            setGridConfig({
                columns: columnJson,
                dataState: filterData,
            });
            // }
        } catch (error) {
            console.log('Error parsing grid layout JSON:', error);
        }
    }, [gridLayouts?.data]);

    // ----------------------------------------------------------------------------------------

    return (
        <Card elevation={0} className="">
            <CardHeader
                className="subHead"
                title={
                    <Typography variant="h3" color="textPrimary">
                        Assigned inspections
                    </Typography>
                }
            />
            <CardContent className="formContainer">
                <Grid container spacing={2}>
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <label>Available Workorders:&nbsp;</label>
                        {/* <strong>-</strong> */}
                    </Grid>
                    <Grid item lg={12} sm={12} xl={12} xs={12} display={'flex'} flexDirection={'column'}>
                        <SiTrackGrid
                            fileTitle='assigned_workorder_inspection'
                            columns={assignedWorkOrderColumns}
                            dataItemKey="workOrderID"
                            actionPermissions={{
                                export: UserPermissionName.DOWNLOAD_GRID,
                            }}
                            // currentPageSize={10}
                            isBusy={isLoading || isLoadingGridLayout}

                            // -----------------Grid Layout-------
                            dataItems={filteredAssignedWorkOrders || []}
                            reorderable
                            handleSearch={handleInputChange}
                            handleSaveLayout={handleSaveLayout}
                            isSaveLayout={true}
                            gridConfigFromApi={gridConfig}
                            handleResetLayout={handleResetLayout}
                            reFixPageNumber
                        // -----------------Grid Layout-------
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}